import React from "react";
import styled from "styled-components";
import { TransitionWrapper, useIsInViewport } from "@trailhead/core-ui";

const StyledImage = styled.img`
    display: flex;
    align-self: flex-start;
    max-height: 33rem;
    max-width: 100%;
    object-fit: scale-down;
    pointer-events: none;
`;

export type ImageWithTransitionProps = {
    src: string;
    size: {
        width: number;
        height: number;
    };
    useScrollTransition?: boolean;
}

export const ImageWithTransition: React.FC<ImageWithTransitionProps> = ({ src, size, useScrollTransition = false }) => {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const ref = React.useRef(null);
    const inViewport = useIsInViewport(ref);

    const getImage = () => <StyledImage 
        ref={ref} 
        src={src} 
        height={isLoaded ? undefined: size.height} // this sets the initial height before load so that the content doesn't grow/shrink in size 
        onLoad={() => setIsLoaded(true)} 
    />;

    return useScrollTransition ? (
    <TransitionWrapper isLoaded={isLoaded && inViewport}>
        {getImage()}
    </TransitionWrapper>
    ) :getImage();
};
